<template>
  <div id="app">
    <el-container style="flex-direction: column;">
      <!-- <el-header>
        <div class="logo" @click="goHome" style="display: flex;flex-direction: row;justify-content: center;align-items: center;width: 60%;">
          <img src="@/assets/img/cszq_logo.png" alt style="width: 160px;height: 40px;"/>
          <div style="padding-left: 10px;">长胜证券</div>
        </div>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
          active-text-color="#ff821f"
        >
          <el-menu-item  v-for="item in navList" :index="item.path" :key="item.id">
            {{item.name}}
          </el-menu-item>
        </el-menu>
      </el-header> -->
      <el-main>
        <router-view />
      </el-main>
      <div class="footer">
        <div class="footer-content">
          <ul class="content-nav">
            <!-- <li>
              <p>About G-STAR</p>
              <span>History</span>
              <span>Culture</span>
              <span>Qualification</span>
              <span>Partners</span>
            </li>
            <li>
              <p>新闻资讯</p>
              <span>公司新闻</span>
              <span>行业动态</span>
            </li>
            <li>
              <p>产品中心</p>
              <span>介绍视频</span>
              <span>管理模式</span>
              <span>平台目标</span>
              <span>功能模块</span>
            </li> -->
            <li>
              <p>联系我们</p>
              <span>服务电话：+852-67649713</span>
              <span>客服QQ：8568866</span>
              <span>工作时间：08:30-20:30</span>
              <span>法定节日：13:00-20:00</span>
            </li>
          </ul>
          <ul class="content-nav">
            <li>
              <p style="text-align: center;width: 100%;">苹果/安卓下载</p>
              <img src="./assets/img/download_qrcode.jpeg" alt />
            </li>
          </ul>
        </div>
        <!-- <div class="copyright">
          <span>科建版权所有</span>
        </div> -->
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false,
      navList:[
        // {
        //   id:0,
        //   name:'Home',
        //   path:'/'
        // },
        // {
        //   id:1,
        //   name:'G-START AND ECOLOGY',
        //   path:'/sdgs'
        // },
        // {
        //   id:2,
        //   name:'Products center',
        //   path:'/product'
        // },
         {
           id:4,
           name:'长胜证券',
           path:'/cszq'
         },
        // {
        //   id:3,
        //   name:'About G-START',
        //   path:'/goin'
        // }
      ]
    };
  },
  // 路由监听
  watch: {
    $route(to, from) {
      //如果跳转的页面是menuList里面defaultActive就改变
      this.navList.find(item => {
        if (item.path === to.path) {
          this.defaultActive = item.path;
        }
      })
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    },
    handleScroll() {
      let top = Math.floor(document.documentElement.scrollTop || document.body.scrollTop);
      // console.log(top);
    },
    goHome() {
      this.$router.push("/");
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.el-header {
  width: 100vw;
  display: flex;
  justify-content: space-between;
  align-content: center;
  margin: 0 auto;
  position: fixed;
  z-index: 10;
  background-color: #fff;

  .logo {
    width: 280px;
    padding: 10px;
    cursor: pointer;
    img {
      width: 100%;
      line-height: 60px;
    }
  }
}
.el-menu {
  width: 70%;
}
.el-menu-item.is-active {
    border-bottom: 2px solid #ff821f;
    color: #303133;
}
.el-main {
  padding: 0 !important;
}

.footer {
  // width: 100vw;
  bottom: 0px;
  height: 220px;
  overflow: hidden;
  background: linear-gradient(to top, #cde5d9, #e9f1ec);
  padding: 30px 10px 20px;
  border-top: 2px solid rgba(160, 200, 180, 0.3);
  box-shadow: inset 0 6px 12px rgba(255, 255, 255, 0.5);
  border-radius: 20px 20px 0 0;
  backdrop-filter: blur(4px);
  color: #224433;
  font-family: "Noto Sans SC", sans-serif;
  // background-color: #;
  &-content {
    width: 1240px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
        p {
          font-size: 20px;
          color: #125688;
          padding: 10px 0;
        }
        span {
          color: #224433;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }
    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .copyright {
    height: 30px;
    background: #125688;
    span {
      color: #fff;
      line-height: 30px;
    }
  }
}
</style>
